export enum ECoachTicketSenderType {
  Coach = 1,
  Admin = 2,
}
